import React, { useEffect, useRef, useState } from "react";
import WidgetLoading from "../../../widget/WidgetLoading";
import Config from "../../../config/Config";
import { WarningOutlined } from '@ant-design/icons';
import WidgetAjax from "../../../widget/WidgetAjax";
import { notification, Button } from 'antd';
import WidgetMessage from "../../../widget/WidgetMessage";
import WidgetModal from "../../../widget/WidgetModal";
import { setXinZi } from '../../utils';
import { useHistory } from 'react-router-dom';
import { checkLogin } from '../utils'
import './index.scss';

// 默认操作数据信息列表
const defaultDataList = [
    // { label: "更新", props: "createTime" },
    // { label: "浏览", props: "job_views", type: 'num' },
    // { label: "报名", props: "job_signUp", type: 'num' },
    // { label: "电话", props: "job_tel", type: 'num' },
    // { label: "收藏", props: "job_favors", type: 'num' },
];

const path = Config.getBasePath();

const DetailHead = ({
    infoLoading = false, // 页面loading加载
    info = {}, // info信息
    dataNumList = defaultDataList, // 
    reloadInfo = () => { }, // 重新加载岗位信息
    headerOperation = ['code'],
    history,
}) => {
    const [phone, setPhone] = useState(undefined);
    const [modalRef, setModalRef] = useState(null);
    const [wechartCode, setWechartCode] = useState(null);
    const headOprationList = [
        { name: "微信扫码分享", icon: <img src={require('../../../img/enterprise/share.png')} />, onClick: () => { }, type: "code" },
    ];

    const collectJob = () => {

        if (!checkLogin()) {
            WidgetMessage.warning('请先登录！');
            history.push({ pathname: "/login" });
            window.location.reload();
            return false;
        }

        let params = {
            job_id: info?.id,
        }
        const onFavor = (res) => {
            if (res.status == 0) {
                WidgetMessage.success(info.favor ? "已取消收藏！" : "收藏成功!");
                if (reloadInfo) {
                    reloadInfo();
                }
            } else {
                WidgetMessage.error(res.message);
            }
        }
        let url = info?.favor ? '/job/unfavor' : '/job/favor';
        WidgetAjax.ajax({ url: path + url, params, callback: onFavor });
    }

    const getWechartShare = () => {
        WidgetAjax.ajax({
            url: path + '/weixin/wmp_qrcode',
            params: {
                application: "wmp|pzz",
                scene: `shareID=${info.id}`,
                page: `pages/laborHome/postDetail/postDetail`
            },
            callback: (res) => {
                if (res.status == 0) {
                    setWechartCode(res.result.result);
                }
            }
        });
    }


    // 处理信息展示
    const setDealWithValue = (data) => {
        switch (data.type) {
            case 'num':
                return info[data.props] || 0
            default:
                return data.props && data.props !== '' ? (info[data.props] ?? '-') : '-'
        }
    }
    // 复制电话
    const copyPhone = async (phone) => {
        try {
            await navigator.clipboard.writeText(phone);
            WidgetMessage.success('复制成功！');
        } catch (err) {
            WidgetMessage.error('复制失败： ', err);
        }
    }
    // 立即报名
    const handleSignUp = () => {
        if (!checkLogin()) {
            WidgetMessage.warning('请先登录！');
            history.push({ pathname: "/login" });
            window.location.reload();
            return false;
        }
        WidgetAjax.ajax({
            url: path + "/job/application_add",
            params: { job_id: info.id },
            callback: (res) => {
                if (res.status == 0) {
                    WidgetMessage.success('报名成功！');
                    if (reloadInfo) {
                        reloadInfo();
                    }
                } else {
                    WidgetMessage.error(res.message)
                }
            },
        });
    }


    useEffect(() => {
        if (info && info.id && info.id !== '') {
            getWechartShare();
        }
    }, [])

    return (
        <div className="component-head-wrap" component-data={Config.getSourcePath()}>
            <WidgetLoading loading={infoLoading}>
                <div className="component-head-head">
                    <div className="component-head-title-box">
                        <div className="component-head-title-box-inside">
                            <span>{info.JOBNAME}</span>
                            {
                                info.IMPORTANCE && info.IMPORTANCE == 2
                                    ? <img src={require('../../../img/enterprise/急招.png')} />
                                    : <></>
                            }

                            {/* <img src={require('../../../img/enterprise/代招.png')} /> */}
                            <div className="component-head-title-salary">
                                {
                                    setXinZi(info)
                                }
                                {info?.SALPAY == "11" ? "元/小时" : ""}
                                {info?.SALPAY == "12" ? "元/天" : ""}
                                {info?.SALPAY == "13" ? "元/周" : ""}
                            </div>
                        </div>
                        <div className="component-head-btn">
                            <div className="component-head-btn-item component-head-collect" onClick={() => collectJob()}>
                                {
                                    info.favor
                                        ? <img src={require('../../../img/pinzhunzhun/dataSource/favorite.png')} />
                                        : <img src={require('../../../img/pinzhunzhun/dataSource/noFavorite.png')} />
                                }
                                <span>
                                    {
                                        info.favor
                                            ? '已收藏'
                                            : '收藏'
                                    }
                                </span>
                            </div>
                            <div
                                className={`component-head-btn-item component-head-baoming`}
                                onClick={() => {
                                    if (!(info && info.application)) {
                                        handleSignUp()
                                    }
                                }}
                            >
                                {
                                    info && info.application
                                        ? <span>已投递</span>
                                        : <span>立即投递</span>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="component-head-bottom">
                        <ul className="component-head-list">
                            {
                                dataNumList && dataNumList.length > 0
                                    ? dataNumList.map((item, index) => {
                                        return <li key={index}>
                                            <label>{item.label}</label>
                                            <span>{setDealWithValue(item)}</span>
                                        </li>
                                    })
                                    : defaultDataList.map((item, index) => {
                                        return <li key={index}>
                                            <label>{item.label}</label>
                                            <span>{setDealWithValue(item)}</span>
                                        </li>
                                    })
                            }
                        </ul>
                        <div className="componet-head-other-btn">
                            {
                                headOprationList
                                    ? headOprationList.map((btnItem, btnIdnex) => {
                                        if (headerOperation.includes(btnItem.type)) {
                                            return <div key={btnIdnex} className={`componet-head-other-btn-item ${btnItem.type == 'code' ? 'componet-head-other-btn-item-code' : ""}`}>
                                                {
                                                    btnItem.type == 'favor'
                                                        ? <>
                                                            {
                                                                info.favor
                                                                    ? <>
                                                                        {btnItem.activeIcon}
                                                                        <span onClick={() => btnItem.onClick(btnItem)}>{btnItem.activeName}</span>
                                                                    </>
                                                                    : <>
                                                                        {btnItem.icon}
                                                                        <span onClick={() => btnItem.onClick(btnItem)}>{btnItem.name}</span>
                                                                    </>
                                                            }
                                                        </>
                                                        : btnItem.type == 'code'
                                                            ? <>
                                                                {btnItem.icon}
                                                                <span onClick={() => btnItem.onClick(btnItem)}>{btnItem.name}</span>
                                                                <div className="enterprise-detail-header-share-code">
                                                                    <img src={`data:image/png;base64,${wechartCode}`} />
                                                                    <div className="">打开微信扫一扫</div>
                                                                </div>
                                                            </>
                                                            : <>
                                                                {btnItem.icon}
                                                                <span onClick={() => btnItem.onClick(btnItem)}>{btnItem.name}</span>
                                                            </>
                                                }

                                            </div>
                                        }
                                    })
                                    : <></>
                            }
                        </div>
                    </div>
                </div>
            </WidgetLoading>
            <WidgetModal
                onRef={ref => setModalRef(ref)}
                options={{
                    title: '电话',
                    modalType: 'form',
                    width: "600px"
                }}
            >
                <div>
                    {phone}
                    <Button color="danger" variant="link" onClick={() => copyPhone(phone)}>
                        复制
                    </Button>
                </div>
            </WidgetModal>
        </div>
    )
}

export default DetailHead;